import Metric from "src/AngularJS/Models/metric";
import MetricData from "src/AngularJS/Models/metric-data";
import { ErrorCode } from "src/shared/models/error-code.model";

export interface KpiData {
    metrics: KpiDataObj[];
    Error: ErrorCode;
}

export interface KpiDataObj {
    metric: Metric;
    metricData: MetricData;
    color: string;
}

export enum Views {
    Horizontal = 0,
    Vertical = 1,
}

enum OldObjectivesColors {
    Red = "#DF1F26",
    Yellow = "#F0CE14",
    Blue = "#0D4E98",
    Green = "#97C93C",
    Orange = "#F16622",
}

enum NewObjectivesColors {
    Red = "#FFB2B2",
    Yellow = "#FAF4B9",
    Blue = "#BFD8FF",
    Green = "#DAF3B2",
    Orange = "#FFD299",
}

/**
 * Transforms an old hex color string representing objectives into a new hex color string.
 * If the input color does not match any predefined old color, it is returned as is.
 *
 * @param color - The old hex color string representing an objective.
 * @returns The corresponding new hex color string, or the original color if not matched.
 */
export const getObjectiveColor = (color: string): string => {
    switch (color) {
        case OldObjectivesColors.Red:
            return NewObjectivesColors.Red;
        case OldObjectivesColors.Yellow:
            return NewObjectivesColors.Yellow;
        case OldObjectivesColors.Blue:
            return NewObjectivesColors.Blue;
        case OldObjectivesColors.Green:
            return NewObjectivesColors.Green;
        case OldObjectivesColors.Orange:
            return NewObjectivesColors.Orange;
        default:
            return color;
    }
};
